<template>
  <div>
    <v-row v-if="!isValid">
      <v-col cols="12" class="text-center">
        <v-alert
          dense
          outlined
          border="left"
          class="mx-4 text-center my-0"
          color="warning"
        >
          <p class="body-2 mb-0">
            <v-icon color="warning" class="mr-2">mdi-alert-outline</v-icon>
            Las siguientes acciones tienen que ser de tipo
            <strong>{{ contratosValidosTexto }}</strong>
          </p>
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="12" class="text-center">
        <v-alert
          dense
          outlined
          border="left"
          class="mx-4 text-center my-0"
          color="success"
        >
          <p class="body-2 mb-0">
            <v-icon color="success" class="mr-2"
              >mdi-check-circle-outline</v-icon
            >
            Todas las acciones son traspasables.
          </p>
        </v-alert>
      </v-col>
    </v-row>

    <v-card class="mb-4" v-if="accionesNoValidas.length">
      <v-card-title>
        Selecciona las acciones y cambiales el tipo de contrato para añadirlas.
      </v-card-title>
      <v-card-text>
        <!-- accionesValidas.includes(accion.tipoAccion_id) -->
        <v-data-table
          :headers="headerAcciones"
          :items="accionesNoValidas"
          :value="accionesEditadas"
          @input="
            $store.dispatch('moverAcciones/setAccionesEditadas', {
              acciones: $event,
            })
          "
          show-select
        >
          <!-- @input="$store.dispatch('moverAcciones/setAccionesNoValidas', $event)" -->
          <!-- :value="accionesCambiarContrato" -->

          <!-- Técnico -->
          <template v-slot:item.user.name="{ item }">
            <v-chip outlined>
              <v-avatar left :color="item.user.color">
                <span class="white--text">
                  {{ item.user.avatar }}
                </span>
              </v-avatar>
              {{ item.user.name }}
            </v-chip>
          </template>

          <!-- Elegir el tipo de contrato -->
          <template v-slot:item.contrato.contrato="{ item }">
            <!-- !contratosValidos
                  .map((contrato) => contrato.id)
                  .includes(item.contrato.id) -->
            <v-select
              v-model="item.contrato"
              :items="contratosValidos"
              :error="
                accionesEditadas.map(accion => accion.id).includes(item.id) && item.contrato.length === 0
              "
              @change="() => {
                if(!item.contrato.ambitos.map(ambito => ambito.id).includes(item.ambito.id))
                  item.ambito = ''
              }"
              label="Contrato"
              return-object
              item-text="contrato"
              item-value="id"
            ></v-select>
          </template>

          <!-- Elegir el ambito -->
          <template v-slot:item.ambito.ambito="{ item }">
            <v-select
              v-model="item.ambito"
              :items="item.contrato.ambitos"
              :error="
                accionesEditadas.map(accion => accion.id).includes(item.id) && item.contrato && !item.ambito
              "
              return-object
              label="Ámbito"
              item-text="ambito"
              item-value="id"
            ></v-select>
          </template>

          <!-- Fecha -->
          <template v-slot:item.fecha="{ item }">
            {{ formatDate(item.fecha) }}
          </template>

          <!-- Comentarios -->
          <template v-slot:item.comentarios="{ item }">
            <v-textarea
              v-model="item.comentarios"
              readonly
              hide-details
              rows="1"
            ></v-textarea>
          </template>

          <!-- Desplazamiento -->
          <template v-slot:item.desplazamiento="{ item }">
            <v-checkbox v-model="item.desplazamiento" disabled></v-checkbox>
          </template>

          <!-- Fura horas -->
          <template v-slot:item.fuera_horas="{ item }">
            <v-checkbox v-model="item.fuera_horas" disabled></v-checkbox>
          </template>

          <!-- Asistencia minia -->
          <template v-slot:item.asistencia_minima="{ item }">
            <v-checkbox v-model="item.asistencia_minima" disabled></v-checkbox>
          </template>

          <!-- Abono -->
          <template v-slot:item.abono="{ item }">
            <v-checkbox v-model="item.abono" disabled></v-checkbox>
          </template>

          <!-- APV -->
          <template v-slot:item.apv="{ item }">
            <v-checkbox v-model="item.apv" disabled></v-checkbox>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <!-- AQUI FALTA PONER LA TABLA DE CAMBIAR CONTRATOS / AMBITOS.... -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import formatearFecha from "../../mixins/formatearFecha";

export default {
  mixins: [formatearFecha],

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      isValid: "moverAcciones/isValid",
      headerAcciones: "acciones/headers",
      accionesNoValidas: "moverAcciones/accionesNoValidas",
      accionesEditadas: "moverAcciones/accionesEditadas",
      contratosValidosTexto: "moverAcciones/contratosValidosTexto",
      contratosValidos: "moverAcciones/contratosValidos",
    }),
  },
};
</script>

<style>
</style>